import { render, staticRenderFns } from "./CustomerRouteList.vue?vue&type=template&id=2bb72740&scoped=true&"
import script from "./CustomerRouteList.vue?vue&type=script&lang=js&"
export * from "./CustomerRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb72740",
  null
  
)

export default component.exports